import React from 'react';

import './Drawer.scss';
import { CSSTransition } from 'react-transition-group';

export interface Props {
  title: string;
  textContent: string;
  content?: JSX.Element[] | JSX.Element;
  children?: JSX.Element[] | JSX.Element;
  assets?: JSX.Element;
  isOpen: boolean;
  timeout: number;
}

export const Drawer = ({
  title,
  textContent,
  content,
  children,
  assets,
  isOpen,
  timeout,
}: Props): JSX.Element => {
  return (
    <CSSTransition
      in={isOpen}
      classNames="drawer__wrapper"
      timeout={timeout}
      unmountOnExit
    >
      <div className="drawer__wrapper" data-testid="drawerWrapper">
        <div className="drawer__text-wrapper">
          <h1 className="drawer__title">{title}</h1>
          <div>
            <p className="drawer__subtitle">{textContent}</p>
            {content}
          </div>
          <div className="drawer__buttons-wrapper">{children}</div>
        </div>
        {assets}
      </div>
    </CSSTransition>
  );
};
